import { useEffect, useState } from "react";
import { v4 as uuidV4 } from "uuid";
import { useActivityCompletion } from "../../../hooks/useActivitiesCompletion";
import { shuffle } from "../../../shared/helpers";

const useMatchPicturesWithWords = (
	activity: { word: string; imageUrl: string }[],
	activityId: string,
) => {
	const [wordsToDrop, setWordsToDrop] = useState<
		{ word: string; index: number; id: string; correct: boolean | undefined }[]
	>([{ word: "", index: 0, id: "", correct: undefined }]);
	const [fireworksTrigger, setFireworksTrigger] = useState(false);
	const { triggerActivityCompletion } = useActivityCompletion();

	const [cards, setCards] = useState<
		{
			word: string;
			currentIndex: number;
			imageUrl: string;
			originalIndex: number;
			id: string;
			correct: boolean | undefined;
		}[]
	>([
		{
			word: "",
			currentIndex: 0,
			imageUrl: "",
			originalIndex: 0,
			id: "",
			correct: undefined,
		},
	]);

	useEffect(() => {
		if (!activity) return;

		const newCards = activity.map((card, index) => {
			return {
				...card,
				id: uuidV4(),
				word: "",
				originalIndex: index,
				currentIndex: index,
				correct: undefined,
			};
		});
		setCards(newCards);

		const onlyWords = activity?.map(({ word }) => word);
		const shuffledWords = shuffle(onlyWords);

		const wordWithIndex = shuffledWords.map((word, index) => {
			return {
				id: uuidV4(),
				word,
				index,
				correct: undefined,
			};
		});

		setWordsToDrop(wordWithIndex);
	}, [activity]);

	const reset = () => {
		const newCards = activity?.map((card, index) => {
			return {
				...card,
				id: uuidV4(),
				word: "",
				originalIndex: index,
				currentIndex: index,
				correct: undefined,
			};
		});
		setCards(newCards);

		const onlyWords = activity?.map(({ word }) => word);
		const shuffledWords = shuffle(onlyWords);

		const wordWithIndex = shuffledWords.map((word, index) => {
			return {
				id: uuidV4(),
				word,
				index,
				correct: undefined,
			};
		});

		setWordsToDrop(wordWithIndex);
	};

	const checkAnswer = async () => {
		const allCorrect = cards.every((card, index) => {
			return card.word === activity[index].word;
		});

		const newCards = cards.map((card) => {
			return {
				...card,
				correct:
					card.word === activity[card.currentIndex].word ? true : undefined,
			};
		});

		setCards(newCards);

		if (allCorrect) {
			setFireworksTrigger(true);
			await triggerActivityCompletion(activityId, 16, reset);
			return true;
		}
		return false;
	};

	return {
		cards,
		setCards,
		wordsToDrop,
		setWordsToDrop,
		checkAnswer,
		reset,
		fireworksTrigger,
		setFireworksTrigger,
	};
};

export default useMatchPicturesWithWords;
